<button class="mui-hero-scroll-fab" (click)="onClick()" *ngIf="!scrolledToBottom" [@scrollBtnAnimation]>
  <mui-icon [font]="'fa'" [name]="'chevron-double-down'" class="mui-hero-scroll-fab__icon"></mui-icon>
</button>
